import { Button, Checkbox, Flex, Table, Text } from '@mantine/core'
import classes from './AdminSettings.module.css'
import { DATA_TYPES } from '@constants/dataTypes'

export const CustomFieldsControlDataType = () => {
  const rows = DATA_TYPES.map((item) => (
    <Table.Tr key={item.dataType}>
      <Table.Td>
        <Checkbox />
      </Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.dataType}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.description}</Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th w={30} />
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Data type
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Description
              </Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
      <Flex p="md" mt="lg" justify="flex-end" gap="xs">
        <Button size="md" variant="default">
          Cancel
        </Button>
        <Button size="md">Next</Button>
      </Flex>
    </>
  )
}
